import { http } from '../../../../api/http';
import type { ConciliacionBancaria, ConciliarRequest } from '../types/conciliacion';

const ENDPOINT = '/tesoreria/conciliacion';

export class ConciliacionBancariaService {
  public static async getConciliacion(idCajaBanco: number, ejercicio: string, periodo: string): Promise<ConciliacionBancaria> {
    const response = await http.get(`${ENDPOINT}?idCajaBanco=${idCajaBanco}&ejercicio=${ejercicio}&periodo=${periodo}`);
    return response.data;
  }

  public static async conciliar(request: ConciliarRequest): Promise<void> {
    await http.post(`${ENDPOINT}/conciliar`, request);
  }

  public static async desconciliar(ids: number[]): Promise<void> {
    await http.post(`${ENDPOINT}/desconciliar`, ids);
  }

  public static async aplicar(id: number): Promise<void> {
    await http.post(`${ENDPOINT}/aplicar/${id}`);
  }
}
